import styled from 'styled-components';

export const WabiSabiStyled = styled.div``;
